import { render, staticRenderFns } from "./shopCreate.vue?vue&type=template&id=1632fbda&scoped=true&lang=html&"
import script from "./shopCreate.vue?vue&type=script&lang=js&"
export * from "./shopCreate.vue?vue&type=script&lang=js&"
import style0 from "./shopCreate.vue?vue&type=style&index=0&id=1632fbda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1632fbda",
  null
  
)

export default component.exports